import React from 'react';
import { Form, Input, Button, message } from 'antd';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const RegisterSchema = Yup.object().shape({
  username: Yup.string().required('Required'),
  password: Yup.string().min(6, 'Password too short').required('Required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords must match')
    .required('Required'),
});

const Register = () => {
  const { register, login: authLogin } = useAuth();
  const navigate = useNavigate();

  const handleRegister = async (values: {
    username: string;
    password: string;
    confirmPassword: string;
  }) => {
    try {
      await register(values.username, values.password, values.confirmPassword);
      authLogin(values.username, values.password);
      message.success('Registration successful!');
      navigate('/');
    } catch (error) {
      message.error('Registration failed. Please try again.');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-md">
        <h2 className="text-2xl font-bold text-center mb-6">Register</h2>
        <Formik
          initialValues={{
            username: '',
            password: '',
            confirmPassword: '',
            email: '',
            phoneNumber: '',
          }}
          validationSchema={RegisterSchema}
          onSubmit={handleRegister}
        >
          {({ handleSubmit, errors, touched }) => (
            <Form layout="vertical" onFinish={handleSubmit}>
              <Form.Item
                label="Username"
                validateStatus={
                  errors.username && touched.username ? 'error' : ''
                }
                help={
                  errors.username && touched.username ? errors.username : null
                }
              >
                <Field
                  name="username"
                  as={Input}
                  placeholder="Enter your username"
                />
              </Form.Item>

              <Form.Item
                label="Password"
                validateStatus={
                  errors.password && touched.password ? 'error' : ''
                }
                help={
                  errors.password && touched.password ? errors.password : null
                }
              >
                <Field
                  name="password"
                  as={Input.Password}
                  placeholder="Enter your password"
                />
              </Form.Item>

              <Form.Item
                label="Confirm Password"
                validateStatus={
                  errors.confirmPassword && touched.confirmPassword
                    ? 'error'
                    : ''
                }
                help={
                  errors.confirmPassword && touched.confirmPassword
                    ? errors.confirmPassword
                    : null
                }
              >
                <Field
                  name="confirmPassword"
                  as={Input.Password}
                  placeholder="Confirm your password"
                />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" className="w-full">
                  Register
                </Button>
              </Form.Item>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Register;
